import l18n from '../../shared/strings';

const DEFAULT_KEYWORD_NAME = 'New keyword';
const PATH_DELIMITER = '→';

/**
 * @param {string} value
 * @returns {string|null} Error message when invalid, otherwise null.
 */
export function getKeywordNameValidationError(value) {
  const trimmed = (value || '').trim();

  if (!trimmed) {
    return l18n.KEYWORDS.nameEmpty;
  }

  if (trimmed.includes(PATH_DELIMITER)) {
    return l18n.KEYWORDS.nameContainsDelimiter;
  }

  return null;
}

/**
 * @param {string} value
 * @param {Array<{ path: string }>} allNodes
 * @param {{ excludeName?: string }} [options]
 * @returns {true|string}
 */
export default function validateKeywordName(value, allNodes = [], options = {}) {
  const charError = getKeywordNameValidationError(value);
  if (charError) {
    return charError;
  }

  const normalized = value.trim().toLowerCase();
  const excludeNormalized = options.excludeName ? options.excludeName.trim().toLowerCase() : null;

  const checkName = (item) => {
    const itemName = item.path.split(PATH_DELIMITER).pop().toLowerCase();
    if (excludeNormalized && itemName === excludeNormalized) {
      return false;
    }
    return itemName === normalized;
  };

  if (allNodes.some(checkName)) {
    return l18n.KEYWORDS.alreadyExistsInWorkspace;
  }

  return true;
}

export function getDefaultKeywordName(allNodes = [], baseName = DEFAULT_KEYWORD_NAME) {
  for (let i = 1; i < 10000; i += 1) {
    const candidate = i === 1 ? baseName : `${baseName} ${i}`;
    if (validateKeywordName(candidate, allNodes) === true) {
      return candidate;
    }
  }

  return baseName;
}
